import { HashRouter, Route, Routes } from "react-router-dom";
import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import "react-toastify/dist/ReactToastify.css";

// Redux imports
import { Provider } from "react-redux";
import { store } from "./service/redux/store";

// Auth imports
import { AuthProvider } from "./context/AuthContext";
import { ChatProvider } from "./context/ChatContext.jsx";
import ProtectedRoute from "./components/ProtectedRoute";
import AuthLayout from "./_auth/AuthLayout.js";
import ForgotPassword from "./_auth/forms/ForgotPassword.js";
import SigninForm from "./_auth/forms/SigninForm.js";
import SignupForm from "./_auth/forms/SignupForm.js";

// Layout imports
import RootLayout from "./_root/RootLayout.js";
import MarketLayout from "./_root/pages/Market/MarketLayout.jsx";

// Page imports
import MarketHome from "./_root/pages/Market/MarketHome.jsx";
import ThanhLy from "./_root/pages/Market/ThanhLy.jsx";
import HoatDong from "./_root/pages/Market/HoatDong.jsx";
import DienDan from "./_root/pages/Market/DienDan.jsx";
import CategoryPage from "./_root/pages/Market/CategoryDetail/CategoryPage.jsx";
import ProductDetailPage from "./_root/pages/Market/CategoryDetailProperty/ProductDetailPage.jsx";
import ProductDetailPageNew from "./_root/pages/Market/CategoryDetailProperty/ProductDetailPageNew.jsx";
import CreateListingForm from "./_root/pages/Market/listing/CreateListingForm.jsx";
import ServicePage from "./_root/pages/Services/ServicePage.jsx";
import TestAPI from "./TestAPI.jsx";

// Group imports - UI MỚI
import Group2 from "./_root/pages/Group2/index.js";
import PostsNew from "./_root/pages/Group2/PostsNew/index.js";
import DetailPost from "./_root/pages/Group2/DetailPost/index.js";
import Message from "./components/Message/Message";
import MessageDetail from "./components/Message/MessageDetail";
import ChatPage from "./_root/pages/Chat/ChatPage.jsx";

function App() {
  return (
    <main>
      <Provider store={store}>
        <AuthProvider>
          <ChatProvider>
            <HashRouter>
              <Routes>
                {/* Public Auth Routes - Không cần đăng nhập */}
                <Route element={<AuthLayout />}>
                  <Route path="/register" element={<SignupForm />} />
                  <Route path="/login" element={<SigninForm />} />
                  <Route path="/forgot-password" element={<ForgotPassword />} />
                </Route>

                {/* Public Market Routes - Không cần đăng nhập để XEM */}
                <Route path="/market" element={<MarketLayout />}>
                  <Route index element={<MarketHome />} />
                  <Route path="thanh-ly" element={<ThanhLy />} />
                  <Route
                    path="thanh-ly/:categoryID"
                    element={<CategoryPage />}
                  />
                  <Route
                    path="detail/:productID"
                    element={<ProductDetailPage />}
                  />
                  <Route
                    path="detail-new/:productID"
                    element={<ProductDetailPageNew />}
                  />
                  <Route path="hoat-dong" element={<HoatDong />} />
                  <Route path="dien-dan" element={<DienDan />} />
                </Route>

                {/* Protected Create Listing - BẮT BUỘC đăng nhập */}
                <Route
                  path="/market/create-listing"
                  element={
                    <ProtectedRoute>
                      <MarketLayout />
                    </ProtectedRoute>
                  }
                >
                  <Route index element={<CreateListingForm />} />
                </Route>

                {/* Public Root Layout Routes - Không cần đăng nhập để XEM */}
                <Route element={<RootLayout />}>
                  <Route path="/" element={<ServicePage />} />
                  <Route path="/services" element={<ServicePage />} />
                  <Route path="/message" element={<ChatPage />} />
                  <Route path="/message/:userId" element={<ChatPage />} />
                </Route>

                {/* Public Group Routes - Không cần đăng nhập để XEM */}
                <Route path="/group" element={<Group2 />}>
                  <Route index element={<PostsNew />} />
                  <Route path=":slug/:groupId" element={<PostsNew />} />
                  <Route
                    path=":slug/:groupId/threads/:threadSlug/:threadID"
                    element={<DetailPost />}
                  />
                </Route>

                {/* Test Routes - Public */}
                <Route path="/test-api" element={<TestAPI />} />
                {/* <Route path="/test-routes" element={<TestRoutes />} /> */}
              </Routes>
            </HashRouter>
          </ChatProvider>
        </AuthProvider>
      </Provider>
    </main>
  );
}

export default App;
